import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { withRefluxStore, CampaignCreationStore } from "../../../../../Stores";
import { Tooltip } from "..";

import { THEME_PRIMARY } from "./constants";
import * as sc from "./styles";

const DraftButton = ({
  onSaveDraft,
  disabled,
  nrOfDraft = 0,
  draftLimit = 5,
  draftCampaignId,
  isCreatingDraft,
  theme = THEME_PRIMARY
}) => {
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    onSaveDraft();
  }, [onSaveDraft]);

  const isDisabled = useMemo(
    () => isCreatingDraft || disabled || (!draftCampaignId && nrOfDraft >= draftLimit),
    [disabled, draftCampaignId, nrOfDraft, draftLimit, isCreatingDraft]
  );

  return (
    <div data-tip="" data-for={"disabled Draft"}>
      <sc.DraftButton onClick={onClick} disabled={isDisabled} theme={theme}>
        {isDisabled && (
          <Tooltip id={"disabled Draft"} effect="solid" place="top" backgroundColor="#1c1928">
            <span>
              {isCreatingDraft
                ? t("Draft campaign was saved")
                : t(
                    "You have reached the maximum number of drafts. Please contact a campaign manager."
                  )}
            </span>
          </Tooltip>
        )}

        {draftCampaignId ? t("Update draft") : t("Save as draft")}
      </sc.DraftButton>
    </div>
  );
};

export default withRefluxStore(
  DraftButton,
  [CampaignCreationStore],
  ["userProfile", "nrOfDraft", "draftLimit", "draftCampaignId", "isCreatingDraft"]
);
